export interface IHostToWidgetMessage {
    type:
        | 'host-request-payload'
        | 'host-initialization-configuration'
        | 'host-cost-update'
        | 'host-ack'
        | 'auth-credentials';
}

export type AllowedFundSourceType =
    | 'creditcard'
    | 'bankaccount'
    | 'openbank'
    | 'all';

export interface IHostRequestPayloadMessage extends IHostToWidgetMessage {
    type: 'host-request-payload';
    data?: IHostRequestPayload;
}

export interface IHostRequestPayload {
    submitCard: boolean;
    requestId: number;
}

export interface IHostInitializationConfigurationMessage
    extends IHostToWidgetMessage {
    type: 'host-initialization-configuration';
    data: IHostInitializationConfiguration;
}

export interface IHostInitializationConfiguration {
    allowPaymentWithNegativeBalance: boolean;
    allowedFundSourceTypes: Array<AllowedFundSourceType>;
    autobillerFormatting: boolean;
    initialTotal: number;
    showAddCardOnLoadWhenNoValidFundSource: boolean;
}

export interface IHostCostUpdateMessage extends IHostToWidgetMessage {
    type: 'host-cost-update';
    data: IHostCostUpdate;
}

export interface IHostCostUpdate {
    total: number;
}

export interface IHostAckMessage extends IHostToWidgetMessage {
    type: 'host-ack';
}

export interface IAuthCredentialsMessage extends IHostToWidgetMessage {
    type: 'auth-credentials';
    data: IAuthCredentials;
}

export interface IAuthCredentials {
    userInformation: string;
}
